'use strict';
var weak = require('./_collection-weak');

// 23.4 WeakSet Objects
require('./_collection')('WeakSet', function(get){
  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value){
    return weak.def(this, value, true);
  }
}, weak, false, true);


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es6.weak-set.js
// module id = ./node_modules/core-js/modules/es6.weak-set.js
// module chunks = vendor